<span class="cp-title-widget-green" style="text-align: center;">{{ literalsCp?.strCusto | uppercase}}</span>

<div class="po-row np" style="margin-top: 20px;">
  <p style="line-height: 1;">
    <cp-barchart [percent]="taskcost.percentage"
                 [infodescription]="literalsCp?.strApropriado"
                 [textdescription]="literalsCp?.strPlanejado">
    </cp-barchart>
  </p>
</div>

<div class="po-row np" style="margin-top: 20px;line-height: 0.5;">
  <div class="po-xl-5 po-lg-5 po-md-5 po-sm-5 np" style="text-align: right">
    <span class="cp-font-bold" style="font-size: 14px">{{ literalsCp?.strPlanejado }}</span>
  </div>
  <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3 np cp-values" style="padding-left: 3px;">
    <span class="cp-font-normal">{{ taskitem.getFormattedNumber(taskcost.plannedvalue) }}</span>
  </div>
</div>
<div class="po-row np">
  <div class="po-xl-5 po-lg-5 po-md-5 po-sm-5 np" style="text-align: right;">
    <span class="cp-font-bold" style="font-size: 14px;">{{ literalsCp?.strApropriado }}</span>
  </div>
  <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3 np cp-values" style="padding-left: 3px;">
    <span class="cp-font-normal">{{ taskitem.getFormattedNumber(taskcost.appropriatevalue) }}</span>
  </div>
</div>

<div class="po-row np">
  <hr class="cp-div-line np po-xl-12 po-lg-12 po-md-12 po-sm-12" />
</div>
<div class="po-row np cp-div" style="margin-top: 20px;">
  <span class="cp-div-rectangle" style="margin-left: 4px;">
    <span style="font-size: 14px;">{{ literalsCp?.strSaldo | lowercase }}</span>
  </span>
  <span class="cp-font-bold"
    style="font-size: 14px; margin-left: 8px;">{{ taskitem.getFormattedNumber(taskcost.balancevalue)}}</span>
</div>

<po-loading-overlay [hidden]="isHideLoading">
</po-loading-overlay>
